const collapseAll = ({ ids }) => {
  ids.reduce((acc, curr) => ({ ...acc, [curr]: false }), {});
};

export default collapseAll;
